import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import Form from "components/forms/form";
import FieldGrid from "components/grid/field-grid";
import Modal from "components/layout/modal";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import { buildDefaultValues, buildUserValidationSchema } from "lib/entity";
import { FormValues, fromFromValues } from "lib/form";
import { EntityCollection } from "models/list-user-entity-collection";
import { ListEntity } from "models/list-entity";
import { ListEntityField } from "models/list-entity-field";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { userDoPatchEntityCollection } from "services/user/entity-collection";
import { EntityCollectionValue } from "models/list-user-entity-collection-value";

interface EditModalProps {
  listEntity: ListEntity;
  listEntityFields: ListEntityField[];
  entityCollection: EntityCollection;
  onUpdate: () => Promise<void>;
  onClose: () => Promise<void>;
}

const EditModal: FunctionComponent<EditModalProps> = ({
  listEntity,
  listEntityFields,
  entityCollection,
  onUpdate,
  onClose,
}) => {
  const schema = buildUserValidationSchema(listEntityFields);

  const defaultValues = buildDefaultValues(
    listEntityFields,
    entityCollection.entityCollectionValues || [],
  );

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  const buttons: FormButtonInterface[] = [
    {
      ...CancelButton,
      onClick: onClose,
    },
    {
      ...SubmitButton,
    },
  ];

  const onSubmit = async (formValues: FormValues) => {
    // build entity field values
    const changedEntityCollectionValues = fromFromValues(
      entityCollection.entityCollectionValues || [],
      formValues,
    );

    // send request(s) to the server
    await userDoPatchEntityCollection(listEntity.uuid, entityCollection.uuid, {
      entityCollectionValues:
        changedEntityCollectionValues as EntityCollectionValue[],
    });

    // Update data on parent
    onUpdate();

    // close modal
    onClose();
  };

  return (
    <Modal title={"Lisää uusi"} wide>
      <Form methods={methods} onSubmit={onSubmit}>
        <FieldGrid listEntityFields={listEntityFields} />
        <FormButtons buttons={buttons} />
      </Form>
    </Modal>
  );
};

export default EditModal;
